import createKaraokePlayerRoute from "../create-karaoke-player-route";

import SongList from "../../../../views/digibord/content/season/SongList.vue";

export default [
  {
    path: "muziek/:seasonSlug?/",
    name: "SongList",
    component: SongList,
    meta: {
      containerClass: "showSongList",
    },
    children: [...createKaraokePlayerRoute("SongListKaraokePlayer")],
  },
];
